export enum EnvironmentVariables {
  NODE_ENV = 'NODE_ENV',
  DEPLOYMENT_ENV = 'REACT_APP_DEPLOYMENT_ENV',
}
